// istanbul ignore file: doesn't hold any logic
import ResultsHeader from "./ResultsHeader";

export default ResultsHeader;
